export default __webpack_public_path__ + "static/media/automated_shorlisting.31bcfee9.svg";